import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import AppList from '@crema/core/AppList';
import {Person} from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {COLORS} from 'shared/constants/AppEnums';
import DialogModal from 'shared/components/DialogModal';
import ListEmptyResult from '@crema/core/AppList/ListEmptyResult';
import {Avatar, Stack, Typography, Chip, Grid, Divider} from '@mui/material';
import TodoListSkeleton from '@crema/core/AppSkeleton/TodoListSkeleton';

const DialogListApprovalSK = ({open, title, data = undefined, handleClose}) => {
  const {loading} = useSelector((state) => state.common);


  const approveCheck = (length, sequence, index) => {
    console.log(length);
    if (sequence <= index) {
      return (
        <>
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '10px',
              backgroundColor: COLORS.primary,
            }}
          >
            <CloseIcon sx={{fontSize: '10px', color: '#fff'}} />
          </Stack>
          <Chip
            label={
              length == index + 1 ? 'Belum Ditandatangan' : 'Belum Disetujui'
            }
            style={{
              backgroundColor: COLORS.secondary,
            }}
            sx={{
              color: COLORS.primary,
              // marginRight: '10px',
              // marginBottom: '10px'
            }}
            size='small'
          />
        </>
      );
    } else if (sequence > index) {
      return (
        <>
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              width: '20px',
              height: '20px',
              borderRadius: '10px',
              backgroundColor: '#11C15B',
            }}
          >
            <CheckIcon sx={{fontSize: '10px', color: '#fff'}} />
          </Stack>
          <Chip
            label={length == index + 1 ? 'Ditandangani' : 'Disetujui'}
            style={{
              backgroundColor: '#D9F5E5',
            }}
            sx={{
              color: '#11C15B',
              // marginRight: '10px',
              // marginBottom: '10px'
            }}
            size='small'
          />
        </>
      );
    }
  };

  return (
    <DialogModal open={open} title={title} handleClose={handleClose}>
      <AppList
        data={data.approvers}
        renderRow={(item, i) =>
          i !== 0 ? (
            <>
              <Stack
                key={item.id}
                justifyContent={'space-between'}
                direction={'row'}
                sx={{marginBottom: '1rem', marginTop: i < 1 ? '0' : '1rem'}}
              >
                <Grid container alignItems={'center'} spacing={1}>
                  <Grid item sm={7.5}>
                    <Stack direction='row' alignItems={'center'} spacing={4}>
                      <Avatar
                        src={item?.avatar_url || item?.composer_avatar}
                        sx={{width: '50px', height: '50px'}}
                      >
                        <Person sx={{fontSize: '28px'}} />
                      </Avatar>

                      <Stack spacing={1}>
                        {item.is_title ? (
                          <>
                            <Typography variant='h4' fontWeight={'bold'}>
                              {item?.is_title ? item?.display_title : '-'}
                            </Typography>
                            <Typography
                              sx={{
                                color: (theme) => theme.palette.text.disabled,
                              }}
                            >
                              {item?.is_title
                                ? item?.officer?.nama
                                : item?.nama}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography variant='h5' fontWeight={'bold'}>
                              {item?.is_title
                                ? item?.display_title
                                : item?.nama}
                            </Typography>
                            {/* <Typography sx={{ color: (theme) => theme.palette.text.disabled }}>{item?.is_title ? item?.officer?.nama : item?.nama}</Typography> */}
                          </>
                        )}
                      </Stack>
                    
                    </Stack>
                  </Grid>
                  <Grid item sm={4.5}>
                    <Stack direction={'row'} alignItems={'center'} gap={1}>
                      {approveCheck(data.approvers.length, data.sequence, i)}
                    </Stack>
                 
                  </Grid>
               
                </Grid>


              </Stack>
              <Divider />
            </>
          ) : null
        }
        ListEmptyComponent={
          <ListEmptyResult
            loading={loading}
            placeholder={<TodoListSkeleton />}
          />
        }
      />
    </DialogModal>
  );
};

DialogListApprovalSK.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default DialogListApprovalSK;
